import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { useLowestPlanPrice } from '../useLowestPlanPrice';
import { watermarkFileMessages as messages } from './watermarkFileMessages';

interface PaidPlanLineProps {
  className?: string;
}

/**
 * "Paid plan, from $19 a month" under "Remove the watermark" (QA 2026-10-28, lit-7): the button
 * opens a purchase, and the line says so. The price comes from the plan table (`useLowestPlanPrice`).
 */
const PaidPlanLineComponent: React.FC<PaidPlanLineProps> = ({ className }) => {
  const intl = useIntl();
  const price = useLowestPlanPrice();
  return (
    <small className={className} data-testid="watermark-paid-plan">
      {price === null ? intl.formatMessage(messages.paidPlan) : intl.formatMessage(messages.paidPlanFrom, { price })}
    </small>
  );
};

export const PaidPlanLine = TypedMemo(PaidPlanLineComponent);
